<template lang="pug">
  v-content
    v-container.grey.lighten-4
      v-row
        v-col
          pageTitle 伝票詳細
    v-container.indigo.lighten-5
      v-card
        v-card-text(dense)
          v-form
            v-card(v-if="errors.length")
              v-card-text
                v-list-item(v-for="error in (errors)" dense :v-key="error")
                  v-list-item {{ error }}
              v-card-actions
                v-btn(color="blue" text @click="closeErrD") 閉じる
            v-row
              v-col(cols="2")
                v-text-field(v-model="sales_slip.slip_no" label="伝票番号")
              v-col(cols="2")
                v-text-field(v-model="sales_slip.slip_date" label="伝票日付" type="date")
            v-row
              v-col
                v-card(outlined)
                  v-card-text
                    v-autocomplete(
                      v-model="cust"
                      :items="entries"
                      :loading="cloading"
                      :search-input.sync="search"
                      item-text="kana"
                      item-value="id"
                      prepend-icon="mdi-database-search"
                      label="お得意先フリガナ"
                      placeholder="お得意先のフリガナで検索"
                      return-object
                    )
                    span.font-italic お得意先:
                    span.text--primary.pl-4 {{ sales_slip.customer.name }}
                    br
                    //- span.font-italic 伝票上の表示:
                    v-textarea(rows=3 label="ラベル (伝票に表示する内容)"
                      v-model="sales_slip.customer_label"
                    )
                      template(v-slot:append)
                        .keisyo-sel
                          v-combobox(label="敬称" v-model="sales_slip.keisyo" :items="keisyos")
                    v-select(label="入金先口座" :items="bank_accounts"
                      v-model="bank_account_id"
                      item-text="label" item-value="id"
                    )
              v-col
                v-card(outlined)
                  v-card-text
                    v-row(dense)
                      v-col(cols=6)
                        v-text-field(v-model="sales_slip.estimate_date" label="見積書日付" type="date" dense)
                    v-row(dense)
                      v-col(cols=6)
                        v-text-field(v-model="sales_slip.delivery_date" label="納期" dense)
                      v-col(cols=6)
                        v-text-field(v-model="sales_slip.delivery_point" label="納入場所" dense)
                      v-col(cols=6)
                        v-text-field(v-model="sales_slip.term_of_sale" label="取引条件" dense)
                      v-col(cols=6)
                        v-text-field(v-model="sales_slip.validity_period" label="有効期限" dense)
                v-card(outlined)
                  v-card-text
                    v-row(dense)
                      v-col
                        v-text-field(v-model="sales_slip.tax_rate" label="消費税率" dense)
                      v-col
                        v-text-field(v-model="sales_slip.reduced_tax_rate" label="軽減税率" dense)
            v-row
              v-col
                v-data-table(:headers="item_headers" item-key="id"
                  :items="edit_items"
                  :items-per-page="100"
                  :hide-default-footer="true" dense
                )
                  template(v-slot:top)
                    v-toolbar(flat)
                      v-spacer
                      span.font-italic.pl-8 合計
                      span.font-italic.pl-4 税抜き
                      span.pl-4.text--primary {{ nc(sales_slip.total_base_price) }}
                      span.font-italic.pl-4 消費税
                      span.pl-4.text--primary {{ nc(sales_slip.total_tax) }}
                      span.font-italic.pl-4 総額
                      span.pl-4.text--primary {{ nc(sales_slip.total_amount) }}
                      v-spacer
                      v-dialog(v-model="edit_dialog" max-width="640px")
                        template(v-slot:activator="{ on }")
                          v-btn.mb-2(color="primary" small v-on="on") 明細行追加
                        v-card
                          v-card-title
                            span.headline {{ formTitle }}
                          v-card-text
                            v-container
                              v-row
                                v-col(cols="12")
                                  v-text-field(v-model="current_item.item_name" label="品番・商品名")
                                v-col(cols="12" sm="6" md="3")
                                  v-text-field(v-model="current_item.quantity" label="数量")
                                v-col(cols="12" sm="6" md="3")
                                  v-text-field(v-model="current_item.unit" label="単位")
                                v-col(cols="12" sm="6" md="4")
                                  v-text-field(v-model="current_item.unit_price" label="単価")
                                v-col(cols="12" sm="6" md="2")
                                  v-checkbox(v-model="current_item.is_reduced" label="軽減" dense)
                                v-col(cols="12")
                                  v-text-field(v-model="current_item.note" label="備考")
                          v-card-actions
                            v-btn(color="blue darken-1" text @click='edit_save(true)') 保存
                            v-btn(color="blue darken-1" text @click='edit_save(false)') 保存&amp;追加
                            v-spacer
                            v-btn(color="blue darken-1" text @click='edit_cancel') キャンセル
                  template(v-slot:item.action="{item}")
                    v-icon.mr-2(small @click="edit_item(item)") mdi-pencil
                    v-icon.mr-2(small @click="delete_item(item)") mdi-delete-forever-outline
                  template(v-slot:item.quantity="{item}") {{ nc(item.quantity) }}
                  template(v-slot:item.unit_price="{item}") {{ nc(item.unit_price) }}
                  template(v-slot:item.amount="{item}") {{ nc(item.amount) }}
            v-row
              v-col
                v-card(outlined)
                  v-card-text
                    | 備考:
                    span.text--primary.pl-4 {{ has_reduced ? '※ 軽減税率適用' : '' }}
                    br
                    //- pre.text--primary {{ sales_slip.customer.note }}
                    v-textarea(
                      v-model="sales_slip.note"
                      rows=4
                      append-icon="mdi-chevron-down-circle"
                      @click:append="open_note_dlg"
                    )
                    v-dialog(v-model="note_dialog" max-width="640px")
                      //- template(v-slot:activator="{ on }")
                      //-   v-btn.mb-2(color="primary" small v-on="on") 明細行追加
                      v-card
                        v-card-title
                          span.headline 備考に追加
                        v-card-text
                          v-container
                            v-select(label="追加する内容" :items="notes"
                              v-model="note_to_add"
                            )
                        v-card-actions
                          v-btn(color="blue darken-1" text @click='note_add') 追加
                          v-spacer
                          v-btn(color="blue darken-1" text @click='note_cancel') キャンセル
        v-card-actions
          v-spacer
          v-btn(color="primary" width="100"
            @click="save"
          ) 保存
          v-spacer()
          v-btn(@click="cancel") キャンセル
          v-spacer
</template>

<script>
  import debugLog from '@/utils/debugLog'
  import { getSalesSlip, postSalesSlip, patchSalesSlip } from '@/api/sales_slip'
  import { getCustomers } from '@/api/customer'
  import { getBankAccounts } from '@/api/bank_account'
  import { getSSNoteOpts } from '@/api/ss-note-opt'
  import pageTitle from '@/components/pageTitle'
  import { bank_account2str, percent_str } from '@/utils/helpers'
  // import ToolTipIcon from '@/components/ToolTipIcon'

  const default_item = {
    id: null, sales_slip_id: null,
    item_name: '', line_no: 10000, quantity: null, unit: '', unit_price: null,
    amount: null, tax: null, tax_rate: null, note: null, is_reduced: false
  }

  export default {
    name: 'SalesSlipEdit',
    components: {pageTitle},
    data() { return {
      note_dialog: false,
      edit_dialog: false,
      editedIndex: -1,
      current_item: {},
      errors: [],
      sales_slip: { customer: {}, sales_slip_items: [], bank_account_id: 0 },
      bank_accounts: [],
      notes: [],
      note_to_add: '',
      keisyos: ["御中", "様", "殿"],
      item_headers: [
        {text: '品番・商品名', value: 'item_name'},
        {text: '数量', value: 'quantity', align: 'end'},
        {text: '単位', value: 'unit'},
        {text: '単価', value: 'unit_price', align: 'end'},
        {text: '金額', value: 'amount', align: 'end'},
        {text: '備考', value: 'note'},
        {text: '　', value: 'action', sortable: false}
      ],
      cust: null,
      entries: [],
      search: null,
      cloading: false,
      pre: false
    }},
    created() {
      this.load_bank_accounts()
      this.load_customers()
      this.load_notes()
      if (this.$route.params.id) {
        const self = this
        getSalesSlip(self.$route.params.id).then((res) => {
          self.sales_slip = res.data
          self.cust = res.data.customer
          self.current_item = self.defaultItem()
        })
      } else {
        const self = this
        getSalesSlip(null).then((res) => {
          self.sales_slip = res.data
          self.current_item = self.defaultItem()
          self.cust = res.data.customer
        })
      }
    },
    watch: {
      cust(val) {
        debugLog({cust: val})
        if (this.sales_slip.customer.id !== val.id) {
          this.sales_slip.customer = val
          this.sales_slip.customer_id = val.id
          this.sales_slip.customer_label = val.label
          this.sales_slip.bank_account_id = val.bank_account_id
          this.sales_slip.bank_account = val.bank_account
          this.sales_slip.keisyo = val.keisyo
          this.sales_slip.note = val.note
        }
      },
      current_item: {
        handler: function(nval) {
          // debugLog({nval: nval.is_reduced, pval: this.pre, ci: pval.is_reduced})
          if (nval.is_reduced !== this.pre) {
            this.pre = nval.is_reduced
            if (nval.is_reduced) {
              this.current_item.note = '※軽減税率適用'
            } else {
              this.current_item.note = ''
            }
          }
        },
        deep: true
      },
      edit_dialog (val) {
        val || this.edit_cancel()
      },
    },
    computed: {
      has_reduced () {
        const items = this.sales_slip.sales_slip_items
        let i
        for (i = 0; i < items.length; i++) {
          if (Number(items[i].line_no) >= 0 && items[i].is_reduced) {
            return true
          }
        }
        return false
      },
      edit_items () {
        return this.sales_slip.sales_slip_items.filter(item => { return Number(item.line_no) >= 0 })
      },
      formTitle () {
        return this.editedIndex === -1 ? '新規作成' : '編集'
      },
      bank_account_id: {
        get: function() {
          return this.sales_slip.bank_account_id
        },
        set: function(val) {
          this.sales_slip.bank_account_id = val
          this.sales_slip.bank_account = this.bank_accounts.find(a => a.id === Number(val))
        }
      },
      bank_account_str() {
        if (this.sales_slip.bank_account_id)
          return bank_account2str(this.bank_account)
        else
          return ''
      },
      is_new () {
        return this.editedIndex === -1
      }
    },
    methods: {
      defaultItem() {
        return Object.assign({}, default_item)
      },
      open_note_dlg() {
        this.note_dialog = true
      },
      note_add() {
        if (this.sales_slip.note == null)
          this.sales_slip.note = ''
        this.sales_slip.note = this.note_to_add + '\n' + this.sales_slip.note
        this.note_dialog = false
      },
      note_cancel() {
        this.note_dialog = false
      },
      pstr(val) { return percent_str(val) },
      nc(val) {
        if (val)
          return Number(val).toLocaleString()
        else
          return ''
      },
      load_customers() {
        if (this.entries.length > 0) return
        if (this.cloading) return
        this.cloading = true
        getCustomers({search_items: true}).then(res => {
          this.count = res.data.length
          this.entries = res.data
        }).catch(err => {
          debugLog(err)
        }).finally(() => {
          this.cloading = false
        })
      },
      load_bank_accounts() {
        const self = this
        getBankAccounts().then((res) => {
          debugLog({getBankAccounts_res:  res})
          self.bank_accounts = Object.assign([], res.data.data)
          self.bank_accounts.forEach(item => { item.label = bank_account2str(item) })
          debugLog({getBankAccounts: self.bank_accounts})
        })
      },
      load_notes() {
        const self = this
        getSSNoteOpts().then((res) => {
          let notes = []
          res.data.data.forEach((note) => { notes.push(note.note) })
          self.notes = notes
        })
      },
      edit_item(item) {
        this.editedIndex = this.sales_slip.sales_slip_items.indexOf(item)
        this.current_item = item
        this.edit_dialog = true
      },
      delete_item(item) {
        if (window.confirm('この行を削除します')) {
          const idx = this.sales_slip.sales_slip_items.indexOf(item)
          this.sales_slip.sales_slip_items[idx].line_no = -1
          this.calc_totals()
        }
      },
      edit_save(dclose = true) {
        if (this.current_item.line_no < 10000) {
          debugLog({update: this.current_item})
          this.sales_slip.sales_slip_items[this.editedIndex] = Object.assign({}, this.current_item)
        } else {
          debugLog('create')
          this.sales_slip.sales_slip_items.push(Object.assign({}, this.current_item))
        }
        this.calc_totals()
        if (dclose) {
          this.edit_cancel()
        } else {
          this.clear_edit()
        }
      },
      edit_cancel() {
        this.edit_dialog = false
        this.clear_edit()
      },
      clear_edit() {
        setTimeout(() => {
          this.current_item = this.defaultItem()
          this.editedIndex = -1
        }, 300)
      },
      calc_totals() {
        const tr = this.sales_slip.tax_rate
        const rtr = this.sales_slip.reduced_tax_rate
        let tbp = 0
        let ttax = 0
        let line_no = 1
        this.sales_slip.sales_slip_items.forEach((item) => {
          debugLog({ ssi: item, t: Number(item.line_no) })
          if (Number(item.line_no) >= 0) {
            debugLog(line_no)
            item.line_no = line_no
            line_no += 1
            if (item.is_reduced) {
              item.tax_rate = rtr
            } else {
              item.tax_rate = tr
            }
            if (!isNaN(item.quantity) && !isNaN(item.unit_price)) {
              item.amount = Number(item.unit_price) * Number(item.quantity)
              item.tax = item.amount * item.tax_rate
              ttax += item.tax
              tbp += item.amount
            }
          }
        })
        this.sales_slip.total_amount = tbp + ttax
        this.sales_slip.total_tax = ttax
        this.sales_slip.total_base_price = tbp
      },
      disp_error(error) {
        debugLog(error)
        let errs = []
        let keys = error.data
        for (let key in keys)
          errs.push(key + ' ' + error.data[key])
        this.errors = errs
      },
      closeErrD() {
        this.errors = []
      },
      save() {
        const self = this
        const prms = Object.assign({}, this.sales_slip)
        prms.sales_slip_items_attributes = this.sales_slip.sales_slip_items
        delete prms.sales_slip_items
        delete prms.customer
        delete prms.bank_account
        delete prms.person_in_charge
        if (this.sales_slip.id) {
          patchSalesSlip(prms).then(res => {
            self.$router.push(`/sales_slip/show/${res.data.id}`)
          }, (err) => {
            debugLog(err)
            self.errors = err.data
          })
        } else {
          postSalesSlip(prms).then(res => {
            self.$router.push(`/sales_slip/show/${res.data.id}`)
          }, (err) => {
            debugLog(err)
            self.errors = err.data
          })
        }
      },
      cancel() {
        if (this.sales_slip.id) {
          this.$router.push(`/sales_slip/show/${this.sales_slip.id}`)
        } else {
          this.$router.push(`/sales_slip/list`)
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  div.keisyo-sel
    width: 4rem
</style>
